{
  "activities": {
    "accessoryProvider": "Fournisseur d'accessoire",
    "accessoryRawMaterialProvider": "Fournisseur de matière première",
    "apparel": {
      "duvet": {
        "baffle": "Cloison",
        "farm": "Ferme d'élevage",
        "materialProduction": "Matière première",
        "preProcessor": "Pré-traitement"
      },
      "fabric": {
        "appret": "Finition",
        "coating": "Enduction",
        "dyeing": "Teinture/Impression",
        "lamination": "Laminage",
        "materialProduction": "Matière première",
        "spinning": "Filature",
        "weavingKnitting": "Tissage/Tricotage"
      },
      "leather": {
        "appret": "Finition",
        "dyeing": "Teinture",
        "farm": "Ferme d'élevage",
        "materialProduction": "Abattoir",
        "tanning": "Tannage"
      },
      "manufacturing": "Confection",
      "yarn": {
        "dyeing": "Teinture",
        "materialProduction": "Matière première",
        "spinning": "Filature"
      }
    },
    "brand": "Marque",
    "certifiedEntity": "Entité certifiée",
    "footwear": {
      "assembling": "Assemblage",
      "finishing": "Finition",
      "stitching": "Piquage"
    },
    "noActivity": "Aucune activité",
    "paper": {
      "assembling": "Assemblage",
      "bleaching": "Blanchiment",
      "chemicalTreatment": "Traitement chimique",
      "laminating": "Lamination",
      "manufacturing": "Fabrication",
      "pressing": "Pressage",
      "printing": "Impression",
      "resineRemoving": "Retrait de résine",
      "whiteWashing": "Lavage à blanc"
    },
    "product": {
      "productWashing": "Lavage produit",
      "washing": "Lavage"
    },
    "wood": {
      "assembling": "Assemblage",
      "brushing": "Brossage",
      "calibrationAndCollage": "Calibration et collage",
      "harvesting": "Récolte",
      "manufacturing": "Fabrication",
      "materialDrying": "Séchage",
      "materialPeeking": "Triage",
      "materialPeeling": "Pelage",
      "materialSawing": "Découpe",
      "sanding": "Ponçage"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Sélectionner les vides"
    },
    "applyButton": "Appliquer cette valeur aux {{ itemCount }} éléments sélectionnés.",
    "batchUpdateSuccess": "Mise à jour réussie",
    "batchUpdateSuccessMessage_one": "Requête mise à jour",
    "batchUpdateSuccessMessage_many": "{{count}} requêtes mises à jour",
    "batchUpdateSuccessMessage_other": "{{count}} requêtes mises à jour",
    "info": "Il y a <b>{{count}}</b> autres éléments avec l'activité <b><activity/><b>",
    "labels": {
      "certificate": "Certificat",
      "clientName": "Client",
      "componentName": "Label",
      "componentReference": "Référence",
      "contact": "Partenaire",
      "documentProof": "Preuve de document",
      "informationRequestItemReference": "Requête",
      "informationRequestItemReferenceHint": "Référence du produit, composant ou matériau associé.",
      "materialName": "Matériau",
      "materialProportion": "Proportion",
      "materialReference": "Référence",
      "productCollection": "Collection",
      "productColor": "Couleur",
      "productId": "ID",
      "productionSite": "Site de production",
      "productName": "Label",
      "productReference": "Référence",
      "purchaseOrder": "Bon de commande",
      "purchaseOrderRef": "Référence du bon de commande",
      "reference": "Référence"
    },
    "noDocument": "Aucun document",
    "searchProduct": "Recherche",
    "title": "Réponse groupée"
  },
  "batchPopover": {
    "button": "Réutiliser",
    "certificateText": "Appliquer ce certificat à plusieurs requêtes?",
    "text": "Appliquer cette réponse à plusieurs <activity />?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Certificat",
      "products": "Produits",
      "type": "type"
    },
    "success_one": "{{count}} requête de certificat mise à jour avec succès",
    "success_many": "{{count}} requêtes de certificat mises à jour avec succès",
    "success_other": "{{count}} requêtes de certificat mises à jour avec succès"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Accepté",
    "OPENED": "Ouvert",
    "REJECTED": "Rejeté",
    "SUBMITTED": "En attente"
  },
  "certificates": {
    "actions": {
      "delete": "Supprimer",
      "submit": "Valider",
      "transfer": "Transférer"
    },
    "activityName": "Etape de traçabilité:",
    "labels": {
      "maxIssueDate": "Certificat délivré avant le",
      "purchaseOrder": "Bon de commande ou numéro de facture associé"
    },
    "modal": {
      "areyousure": "Êtes-vous sûr de vouloir supprimer ce certificat (cette action est permanente)?",
      "no": "Non",
      "yes": "Oui, supprimer"
    },
    "noRequests": {
      "closed": "Vous n'avez aucune requête de certificat complétée.",
      "open": "Vous n'avez aucune requête de certificat en attente."
    },
    "productionSite": "Site de production",
    "productionSitePending": "Information du site de production en attente",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Cacher",
        "seeMore": "Voir"
      },
      "productReferences": "Références"
    },
    "reference": "Référence : {{reference}}",
    "select": {
      "placeholder": "Choisir parmi les documents historiques correspondants."
    },
    "upload": {
      "title": "Télécharger un certificat"
    }
  },
  "contactModal": {
    "businessPartnerRepository": {
      "addressUnavailable": "Adresse indisponible",
      "createNewOption": "Créer nouveau : \"{{term}}\"",
      "prefillLoadError": "Impossible de charger les détails de l'entreprise depuis l'annuaire. Vous pouvez toujours modifier le formulaire manuellement.",
      "prefillLoadErrorTitle": "Préremplissage indisponible"
    },
    "labels": {
      "companyCity": "Ville",
      "companyCityPlaceholder": "Paris",
      "companyCityTooltip": "Ville de l'entreprise",
      "companyCountry": "Pays",
      "companyCountryTooltip": "Pays de l’entreprise",
      "companyIsActive": "Actif",
      "companyIsActivePlaceholder": "Actif",
      "companyIsActiveTooltip": "Identifie les partenaires commerciaux actuellement en activité",
      "companyName": "Nom de l’entreprise",
      "companyNamePlaceholder": "Trace for good",
      "companyNameTooltip": "Nom public de l’entreprise partenaire.",
      "companyPostalCode": "Code postal",
      "companyPostalCodePlaceholder": "75000",
      "companyPostalCodeTooltip": "Code postal de l’entreprise",
      "companyRegistrationId": "Identifiant professionnel de l’entreprise",
      "companyRegistrationIdDescription": {
        "DUNS": "Identifiant unique à 9 chiffres attribué par Dun & Bradstreet, utilisé principalement aux États-Unis et dans le commerce international. Format : code numérique à 9 chiffres.",
        "EORI": "Numéro d’identification requis pour les entreprises effectuant des opérations douanières dans l’UE. Format : code pays (ex : FR) + numéro SIRET à 14 chiffres.",
        "GLN": "Global Location Number - Identifiant unique de site ou d’entité juridique selon la norme GS1. Format : code numérique à 13 chiffres.",
        "OTHER": "Identifiant unique de l’entreprise.",
        "RCS": "RCS (numéro du registre du commerce): RCS + ville + SIREN.",
        "VAT": "Numéro d'identification fiscale européen pour les entreprises assujetties à la TVA. Format : code pays (ex : FR) + clé à 2 chiffres + numéro SIREN à 9 chiffres."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "Numéro TVA, CIN, GSTIN, USC, etc.",
      "companyRelationshipType": {
        "AGENT": "Agent",
        "BRAND": "Marque",
        "MANUFACTURER": "Façonnier",
        "OTHER": "Autre",
        "RAW_MATERIAL_SUPPLIER": "Fournisseur de matière première",
        "SUPPLIER": "Fournisseur",
        "TRADER": "Négociant"
      },
      "companyRelationshipTypeName": "Type",
      "companyRelationshipTypeTooltip": "Nature de l’entreprise partenaire, utilisée pour identifier son rôle dans la chaîne d’approvisionnement.",
      "companyStreet": "Rue",
      "companyStreetPlaceholder": "1 av. des Champs Elysées",
      "companyStreetTooltip": "Rue de l’entreprise",
      "companySupplierCode": "Code fournisseur",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Identification courte du partenaire commercial utilisée en interne.",
      "contactInformation": "Contact",
      "coordinates": "Coordonnées",
      "coordinatesPlaceholder": "Entrer les coordonnées",
      "email": "Adresse email",
      "emailPlaceholder": "support@traceforgood.com",
      "emailTooltip": "Adresse email utilisée pour contacter l’entreprise partenaire.",
      "name": "Nom",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Identification usuelle du partenaire commercial, utilisée pour les échanges par mail.",
      "preferredLanguage": "Langage favorisé dans les échanges",
      "tags": "Badges (beta)",
      "tagsPlaceholder": "Ajouter des badges...",
      "tagsTooltip": "Classification interne, note, ou autre information contextuelle adjointe à cette organisation partenaire."
    },
    "messages": {
      "create": {
        "error": "Une erreur est survenue lors de la création du partenaire: {{ error }}",
        "success": "Vous avez créé un nouveau partenaire avec le contact {{ email }}"
      },
      "update": {
        "success": "Vous avez modifié le partenaire avec le contact {{ email }}"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "Nouveau",
      "contact": "Contributeur",
      "you": "vous"
    },
    "placeholders": {
      "contact": "Rechercher"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Activité",
        "tooltip": "Dernière connexion enregistrée pour le partenaire."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} jour",
        "averageResponseTimeValue_many": "averageResponseTimeValue",
        "averageResponseTimeValue_other": "{{nbDays}} jours",
        "name": "Réactivité",
        "tooltip": "Temps moyen pris pour répondre aux requêtes d'information."
      },
      "certificateRequests": {
        "name": "Requêtes certificats"
      },
      "code": {
        "name": "Code",
        "tooltip": "Identification courte du partenaire commercial utilisée en interne."
      },
      "company": {
        "name": "Entreprise",
        "tooltip": "Nom publique officiel de l'entreprise partenaire"
      },
      "contactEmail": {
        "name": "Contact (email)",
        "tooltip": "Mail du contact principal au sein de l'entreprise partenaire."
      },
      "contactName": {
        "name": "Contact (nom)",
        "tooltip": "Nom du contact principal au sein de l'entreprise partenaire."
      },
      "location": {
        "name": "Localisation",
        "tooltip": "Pays de l'entreprise partenaire."
      },
      "productionSiteRequests": {
        "name": "Requêtes sites de production",
        "received": "reçus"
      },
      "productionSites": {
        "name": "Sites de production",
        "tooltip": "Nombre de sites déclarés par le partenaire et nombre de pays distincts."
      },
      "productRequests": {
        "name": "Requêtes produits"
      },
      "reminder": {
        "name": "Relance",
        "tooltip": "Dernière relance adressée au partenaire."
      },
      "requests": {
        "name": "Requêtes",
        "tooltip": "Réponses fournies par le partenaire."
      },
      "status": {
        "name": "Statut",
        "tooltip": "Identifie les partenaires commerciaux actuellement en activité."
      },
      "tags": {
        "name": "Badges",
        "tooltip": "Classification interne, note, ou autre information contextuelle."
      },
      "type": {
        "name": "Type",
        "tooltip": "Nature de l'entreprise partenaire, utilisée pour identifier son rôle dans la chaîne d'approvisionnement."
      }
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    }
  },
  "customFields": {
    "attachment": "Pièce jointe",
    "updateCustomField": {
      "customField": {
        "message": "La valeur du champ personnalisé a été mise à jour et envoyée au client",
        "title": "Valeur du champ personnalisé mise à jour"
      },
      "customFieldProof": {
        "message": "Le certificat de champ personnalisé a été envoyé",
        "title": "Certificat de champ personnalisé envoyé"
      }
    },
    "uploadCustomFieldProofTooltip": "Demander une pièce jointe pour supporter la valeur déclarée"
  },
  "deselectAll": "Désélectionner tout",
  "errors": {
    "axiosMessage": "L'erreur suivante s'est produite : {{message}} \n\n veuillez réessayer ou contacter support@traceforgood.com si l'erreur persiste",
    "reinforcedTraceability": "Vous ne pouvez pas vous assigner à cette requête, veuillez la transférer à la personne appropriée",
    "title": "Une erreur s'est produite"
  },
  "filters": {
    "client": "Client",
    "search": "Recherche",
    "status": {
      "canceled": "Annulée",
      "closed": "Fermée",
      "opened": "Ouverte",
      "placeholder": "Statut"
    },
    "title": "Filtres",
    "type": "Catégorie"
  },
  "item": {
    "brand": "Marque",
    "client": "Client",
    "collection": "Collection",
    "color": "Couleur",
    "component": "Composant",
    "date": "Commande (date)",
    "marketLaunchDate": "Date butoir",
    "material_one": "Matériau",
    "material_other": "Matériaux",
    "name": "Label",
    "partOf": "Partie de",
    "product": "Produit",
    "purchaseOrderRef": "Commande (référence)",
    "reference": "Référence",
    "type": "Catégorie"
  },
  "itemType": {
    "component": "Composant",
    "material": "Matériau",
    "product": "Produit"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "Annuler",
        "no": "Non",
        "title": "Êtes-vous sûr de vouloir annuler cette campagne de traçabilité?",
        "yes": "Oui, annuler"
      },
      "close": {
        "button": "Fermer"
      },
      "eligibleProducts": {
        "checkbox": "Ajouter les détails pour les produits à façon",
        "error": {
          "title": "Erreurs détectées dans le fichier téléchargé"
        },
        "infoBox": {
          "description": {
            "multiple": "La campagne de traçabilité peut commencer dès aujourd'hui pour {{eligibleProductsCount}} produits, portant votre taux de couverture de produits tracés à {{estimatedTraceabilityCoverage}}%",
            "single": "La campagne de traçabilité peut commencer dès aujourd'hui pour 1 produit, portant votre taux de couverture de produits tracés à {{estimatedTraceabilityCoverage}}%"
          },
          "title": {
            "multiple": "{{eligibleProductsCount}} produits éligibles",
            "single": "1 produit éligible"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "Trace {{eligibleProductsCount}} products",
            "none": "Trace products",
            "single": "Trace 1 product"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "Tous les produits de votre catalogue sont actuellement tracés pour soutenir votre stratégie RSE et votre conformité légale.",
          "title": "Félicitations"
        }
      },
      "header": {
        "description": {
          "default": "Trace for good collecte actuellement des informations auprès de vos partenaires commerciaux pour {{tracedProductsCount}}/{{totalProducts}} ({{currentTraceabilityCoverage}}%) produits de votre catalogue",
          "noTraceabilityCampaign": "Lancez votre campagne de traçabilité et commencez à collecter des informations auprès de vos partenaires commerciaux grâce à Trace for good.",
          "runningJob": "Une campagne est en cours de lancement. Afin de garantir les meilleurs standards de qualité et l’intégrité de vos données, une seule campagne peut être lancée à la fois. Nous vous invitons à revenir dans quelques instants pour tracer de nouveaux produits en toute sérénité."
        },
        "title": "Campagne de traçabilité"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "Les informations nécessaires au lancement de la campagne de traçabilité sont manquantes pour {{pendingProductsCount}} produits. Vous pouvez ajouter les détails d'approvisionnement et/ou les compositions détaillées depuis le Data Hub.",
            "single": "Les informations nécessaires au lancement de la campagne de traçabilité sont manquantes pour 1 produit. Vous pouvez ajouter les détails d'approvisionnement et/ou la composition détaillée depuis le Data Hub."
          },
          "title": {
            "multiple": "{{pendingProductsCount}} produits manquent d’informations",
            "single": "1 produit manque d'information"
          }
        }
      },
      "success": {
        "button": "Aller au catalogue produits",
        "description": "Votre campagne de traçabilité a été lancée avec succès. Vos produits sont actuellement tracés pour soutenir votre stratégie RSE et votre conformité légale.",
        "title": "Campagne de traçabilité lancée"
      }
    }
  },
  "maxError": "Doit être inférieur ou égal à {{max}}",
  "minError": "Doit être supérieur ou égal à {{min}}",
  "operation": {
    "component": "Composant",
    "duplicateProductionSite": "A noter: différentes étapes ont été déclarées sur ce site.",
    "material": "Matériau",
    "notOwner": "Requête transférée à {{email}}.",
    "product": "Produit",
    "purchaseOrderRef": "Bon de commande ou numéro de facture associé à ce {{type}}.",
    "reference": "Référence",
    "unknown": "Autre"
  },
  "operationNotCreated": "Une erreur est survenue",
  "operationNotCreatedMessage": "La requête d'information pour cette requête n'a pas encore été créée, veuillez contacter le support à support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "Transférer",
      "transferAll": "Tout transférer"
    },
    "noRequests": {
      "closed": "Vous n'avez aucune requête complétée.",
      "open": "Vous n'avez aucune requête en attente."
    },
    "status": {
      "INVALID": "Incomplet",
      "TOBESUBMITTED": "Prêt pour envoi"
    },
    "transferModal": {
      "success_one": "{{count}} requête de site de production transférée avec succès",
      "success_many": "{{count}} requêtes de site de production transférées avec succès",
      "success_other": "{{count}} requêtes de site de production transférées avec succès",
      "title": "Requête de site de production",
      "transferButton": "Transférer"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Ajouter un site de production",
      "productionSite": "Site de production"
    },
    "placeholders": {
      "productionSite": "Rechercher"
    }
  },
  "reopenRequest": {
    "error": "Échec de réouverture de la requête.",
    "feedback_one": "{{count}} sous-requête annulée",
    "feedback_many": "{{count}} sous-requêtes annulées",
    "feedback_other": "{{count}} sous-requêtes annulées",
    "title": "Êtes-vous sûr de vouloir réouvrir cette requête? (cette action va annuler toutes les sous-requêtes de cette requête)",
    "yes": "Oui!"
  },
  "request": {
    "complete": "Envoyer les réponses finalisées",
    "completeTooltip": "Cliquez ici pour finaliser et clôturer la demande. Les sous-demandes transférées seront envoyées au responsable assigné.",
    "errors": {
      "generic": "Les requêtes n'ont pas pu être récupérées. Veuillez réessayer plus tard."
    },
    "incomplete": "incomplete",
    "labels": {
      "composition": "Composition",
      "requestDate": "Requête (date)"
    },
    "readyToSubmit": "Prêt pour envoi",
    "seeLess": "Masquer la requête",
    "seeMore": "Afficher la requête"
  },
  "requests": {
    "noRequests": {
      "closed": "Vous n'avez complété aucune requête de traçabilité.",
      "open": "Félicitations ! Vous n'avez aucune requête de traçabilité en attente."
    },
    "tabs": {
      "canceled": "Annulée",
      "certificates": {
        "scope": "Certificats et Audits",
        "transaction": "Preuves de transaction"
      },
      "closed": "Complétée",
      "prodsitefield": "Sites de production",
      "traceability": "Traçabilité"
    }
  },
  "requiredError": "Champ requis",
  "selectAll": "Tout sélectionner",
  "sorts": {
    "client": "Client",
    "dueDate": "Date butoir",
    "orderDate": "Date de commande",
    "receptionDate": "Date de réception de la demande",
    "reference": "Référence"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Téléchargé",
    "REJECTED": "",
    "UPLOADED": "Téléchargé"
  },
  "submitModal": {
    "composition": "Composants",
    "confidenceStatement": "Je certifie sur l'honneur que les informations fournies sont correctes et complètes.",
    "confirmation_one": "{{count}} réponse envoyée avec succès",
    "confirmation_many": "{{count}} réponses envoyées avec succès",
    "confirmation_other": "{{count}} réponses envoyées avec succès",
    "error": "Echec de l'envoi des réponses",
    "noRequests": "Vous n'avez aucune requêtes de traçabilité éligible sur cette page.",
    "reference": "Référence",
    "submitButton": "Confirmer ({{ itemCount }})",
    "title": "Sélectionnez les demandes que vous souhaitez soumettre",
    "type": "Type"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "Site de production",
      "status": "Statut",
      "tags": "Badges"
    }
  },
  "tooltips": {
    "contact": "Personne responsable de l'information fournie.",
    "productionSite": "Un site enregistré dans votre référentiel où ont lieu les opérations de fabrication ou de transformation. Chaque site est généralement associé à un seul flux de production, sauf en cas d'intégration de plusieurs opérations.",
    "purchaseOrderRef": "Bon de commande ou numéro de facture associé à ce {{type}}.",
    "reference": "Référence pour identifier le produit, composant ou matériau pour votre fournisseur."
  },
  "transferModal": {
    "success": "Demande de certificat transférée avec succès",
    "title": "Sélectionnez le contact auquel transférer la demande de certificat"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Fournisseur d'accessoire",
    "accessoryRawMaterialProvider": "Fournisseur de matière première",
    "apparel": {
      "duvet": {
        "baffle": "Cloison",
        "farm": "Ferme d'élevage (duvet)",
        "materialProduction": "Matière première (duvet)",
        "preProcessor": "Pré-traitement"
      },
      "fabric": {
        "appret": "Finition (tissu)",
        "coating": "Enduction (tissu)",
        "dyeing": "Teinture/Impression (tissu)",
        "lamination": "Laminage",
        "materialProduction": "Matière première (tissu)",
        "spinning": "Filature (tissu)",
        "weavingKnitting": "Tissage/Tricotage"
      },
      "leather": {
        "appret": "Finition (cuir)",
        "dyeing": "Teinture (cuir)",
        "farm": "Ferme d'élevage (cuir)",
        "materialProduction": "Abattoir",
        "tanning": "Tanneur"
      },
      "manufacturing": "Confection",
      "yarn": {
        "dyeing": "Teinture (fil)",
        "materialProduction": "Matière première (fil)",
        "spinning": "Filature (fil)"
      }
    },
    "brand": "Marque",
    "certifiedEntity": "Entité certifiée",
    "footwear": {
      "assembling": "Assemblage",
      "finishing": "Finition",
      "stitching": "Piquage"
    },
    "noActivity": "Aucune activité",
    "paper": {
      "assembling": "Assemblage papier",
      "bleaching": "Blanchiment",
      "chemicalTreatment": "Traitement chimique",
      "laminating": "Lamination",
      "manufacturing": "Fabrication papier",
      "pressing": "Pressage",
      "printing": "Impression",
      "resineRemoving": "Retrait de résine",
      "whiteWashing": "Lavage à blanc"
    },
    "product": {
      "productWashing": "Lavage produit",
      "washing": "Lavage"
    },
    "wood": {
      "assembling": "Assemblage bois",
      "brushing": "Brossage",
      "calibrationAndCollage": "Calibration et collage",
      "harvesting": "Récolte",
      "manufacturing": "Fabrication bois",
      "materialDrying": "Séchage",
      "materialPeeking": "Triage",
      "materialPeeling": "Pelage",
      "materialSawing": "Découpe",
      "sanding": "Ponçage"
    }
  }
}
